import { defineComponent as v, createBlock as c, openBlock as f, unref as n, withCtx as r, renderSlot as o, normalizeProps as i, guardReactiveProps as l, createVNode as s } from "vue";
import { RevButtonIcon as b } from "@ds/components/ButtonIcon";
import { RevCarousel as g } from "@ds/components/Carousel";
import { RevModalBase as k } from "@ds/components/ModalBase";
import x from "../../icons/generated/IconCross.vue2.js";
import { useI18n as I } from "@ds/plugin";
import B from "../../translations/generic.translations.js";
import { tw as C } from "../../utils/tailwind.js";
const h = /* @__PURE__ */ v({
  name: "RevMediaViewer",
  __name: "MediaViewer",
  props: {
    name: {},
    alternativeButtonLabel: {},
    alternativeNext: {},
    currentIndexId: {},
    tracking: { default: () => ({}) },
    alternativePrevious: {},
    thumbnails: {},
    closeButtonLabel: { default: () => {
    } },
    to: { default: "body" },
    backdropZIndex: { default: () => {
    } },
    currentIndex: {}
  },
  emits: ["open", "close"],
  setup(u) {
    const d = I(), m = u.closeButtonLabel || d(B.buttonClose), p = C`absolute top-1/2 size-full -translate-y-1/2 object-contain`;
    return (e, a) => (f(), c(n(k), {
      "backdrop-z-index": e.backdropZIndex,
      class: "bg-overlap-default-low fixed inset-0 m-auto flex items-center justify-center p-24 md:rounded-lg md:inset-32 lg:max-w-1376",
      name: e.name,
      to: e.to,
      onClose: a[0] || (a[0] = (t) => e.$emit("close", t)),
      onOpen: a[1] || (a[1] = (t) => e.$emit("open"))
    }, {
      default: r(({ close: t }) => [
        s(n(g), {
          "alternative-button-label": e.alternativeButtonLabel,
          "alternative-next": e.alternativeNext,
          "alternative-previous": e.alternativePrevious,
          class: "size-full",
          "current-index": e.currentIndex,
          "current-index-id": e.currentIndexId,
          thumbnails: e.thumbnails,
          tracking: e.tracking
        }, {
          default: r(() => [
            o(e.$slots, "default", i(l({ imgClassNames: p })))
          ]),
          _: 3
        }, 8, ["alternative-button-label", "alternative-next", "alternative-previous", "current-index", "current-index-id", "thumbnails", "tracking"]),
        s(n(b), {
          "alternative-text": n(m),
          class: "absolute right-12 top-12",
          icon: n(x),
          variant: "secondary",
          onClick: () => t({ cause: "dismiss" })
        }, null, 8, ["alternative-text", "icon", "onClick"])
      ]),
      trigger: r(({ open: t }) => [
        o(e.$slots, "trigger", i(l({ open: t })))
      ]),
      _: 3
    }, 8, ["backdrop-z-index", "name", "to"]));
  }
});
export {
  h as default
};
